/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-08-25 10:00:55 */

const Keys = {
  bookingNumber: 'bookingNumber',
  lastName: 'lastName',
  modalHeadline: 'modalHeadline',
  modalText: 'modalText',
  search: 'search',
  bookingError: 'bookingError',
  bookingOverview: 'bookingOverview',
  personalInfo: 'personalInfo',
  editBooking: 'editBooking',
  additionalOffers: 'additionalOffers',
  contactOptions: 'contactOptions',
  bookingNumberError: 'bookingNumberError',
  lastNameError: 'lastNameError',
  bookingPerson: 'bookingPerson',
  changePersonalInfoRequestSubject: 'changePersonalInfoRequestSubject',
  changePersonalInfoRequestHeadline: 'changePersonalInfoRequestHeadline',
  changePersonalInfoRequestBodyMessage: 'changePersonalInfoRequestBodyMessage',
  changePersonalInfoRequestOldValue: 'changePersonalInfoRequestOldValue',
  changePersonalInfoRequestNewValue: 'changePersonalInfoRequestNewValue',
  travellingCompanions: 'travellingCompanions',
  travellingPerson: 'travellingPerson',
  salutation: 'salutation',
  salutationMale: 'salutationMale',
  salutationFemale: 'salutationFemale',
  salutationOther: 'salutationOther',
  firstName: 'firstName',
  email: 'email',
  address: 'address',
  zipCode: 'zipCode',
  birthDate: 'birthDate',
  inputRequired: 'inputRequired',
  mustBeAdult: 'mustBeAdult',
  shouldNotBeNull: 'shouldNotBeNull',
  mustBeLowerThan: 'mustBeLowerThan',
  mustBeOlderThan: 'mustBeOlderThan',
  day: 'day',
  day_plural: 'day_plural',
  yourTravelData: 'yourTravelData',
  paymentData: 'paymentData',
  deposit: 'deposit',
  finalPayment: 'finalPayment',
  refund: 'refund',
  refundInfo: 'refundInfo',
  openPayment: 'openPayment',
  ok: 'ok',
  open: 'open',
  payed: 'payed',
  toBePayed: 'toBePayed',
  yourBookedExtras: 'yourBookedExtras',
  standardDuration: 'standardDuration',
  extension: 'extension',
  extension_plural: 'extension_plural',
  contactSubHeadline: 'contactSubHeadline',
  contactText1: 'contactText1',
  contactText2: 'contactText2',
  phoneText: 'phoneText',
  phoneText2: 'phoneText2',
  phoneText3: 'phoneText3',
  questionChoice1Label: 'questionChoice1Label',
  questionChoice2Label: 'questionChoice2Label',
  topicLabel: 'topicLabel',
  topic1: 'topic1',
  topic2: 'topic2',
  topic3: 'topic3',
  topic4: 'topic4',
  requestLabel: 'requestLabel',
  customerNrLabel: 'customerNrLabel',
  bookingNrLabel: 'bookingNrLabel',
  salutationLabel: 'salutationLabel',
  firstNameLabel: 'firstNameLabel',
  lastNameLabel: 'lastNameLabel',
  streetHouseNrLabel: 'streetHouseNrLabel',
  postalCodeCityLabel: 'postalCodeCityLabel',
  countryLabel: 'countryLabel',
  phoneLabel: 'phoneLabel',
  emailLabel: 'emailLabel',
  emailError: 'emailError',
  submit: 'submit',
  overview: 'overview',
  itinerary: 'itinerary',
  yourDocuments: 'yourDocuments',
  bookingConfirmation: 'bookingConfirmation',
  invoice: 'invoice',
  download: 'download',
  voucher: 'voucher',
  defaultDocumentName: 'defaultDocumentName',
  documentError: 'documentError',
  yourExtras: 'yourExtras',
  availableExtras: 'availableExtras',
  availableExtrasDescription: 'availableExtrasDescription',
  choosenExtraNumber: 'choosenExtraNumber',
  pricePerPerson: 'pricePerPerson',
  seeMore: 'seeMore',
  logout: 'logout',
  callUs: 'callUs',
  telefonNumber: 'telefonNumber',
  openingTime: 'openingTime',
  priceOverview: 'priceOverview',
  travelDate: 'travelDate',
  numberParticipants: 'numberParticipants',
  duration: 'duration',
  groupSize: 'groupSize',
  departureAirport: 'departureAirport',
  flights: 'flights',
  hotel: 'hotel',
  trip: 'trip',
  isNormalGroup: 'isNormalGroup',
  isSmallGroup: 'isSmallGroup',
  isMiniGroup: 'isMiniGroup',
  herEntry: 'herEntry',
  overlayTextBookingNumber: 'overlayTextBookingNumber',
  overlayTextPersonalArea: 'overlayTextPersonalArea',
  overlayTextWelcome: 'overlayTextWelcome',
  yourInsurance: 'yourInsurance',
  noInsuranceSelected: 'noInsuranceSelected',
  totalPrice: 'totalPrice',
  airportSurcharge: 'airportSurcharge',
  airportDiscount: 'airportDiscount',
  stopLocationSurcharge: 'stopLocationSurcharge',
  stopLocationDiscount: 'stopLocationDiscount',
  seasonSurcharge: 'seasonSurcharge',
  seasonalDiscount: 'seasonalDiscount',
  discount: 'discount',
  railAndFlay: 'railAndFlay',
  youExtension: 'youExtension',
  additionalServicesAndSurcharges: 'additionalServicesAndSurcharges',
  requestChange: 'requestChange',
  requestChangeAbort: 'requestChangeAbort',
  requestChangeInfo: 'requestChangeInfo',
  reset: 'reset',
  storePasswordDetails: 'storePasswordDetails',
  phoneEmergencyInfo: 'phoneEmergencyInfo',
  phone: 'phone',
  city: 'city',
  postalCode: 'postalCode',
  streetAndHouseNumber: 'streetAndHouseNumber',
  title: 'title',
  pickUpInfoText: 'pickUpInfoText',
  view: 'view',
  available: 'available',
  availableFrom: 'availableFrom',
  appointmentLetter: 'appointmentLetter',
  generalTravelConditions: 'generalTravelConditions',
  informationPackageTour: 'informationPackageTour',
  travelParticipants: 'travelParticipants',
  travelPerson: 'travelPerson',
  helpAndContact: 'helpAndContact',
  helpAndContactRequest: 'helpAndContactRequest',
  tokenHeadline: 'tokenHeadline',
  tokenText: 'tokenText',
  tokenLabel: 'tokenLabel',
  tokenError: 'tokenError',
  tokenSubmitError: 'tokenSubmitError',
  resendPassword: 'resendPassword',
  login: 'login',
  closeModal: 'closeModal',
  myJourneyLoginModal: 'myJourneyLoginModal',
  changeData: 'changeData',
  travelPlan: 'travelPlan',
  additionalDocument: 'additionalDocument',
  quotation: 'quotation',
  bookingNumberList: 'bookingNumberList',
  eTicket: 'eTicket',
  registrationForm: 'registrationForm',
  subject: 'subject',
  message: 'message',
  send: 'send',
  sending: 'sending',
  yourMessage: 'yourMessage',
  customerData: 'customerData',
  customerNumber: 'customerNumber',
  cancel: 'cancel',
  helpContactHint: 'helpContactHint',
  toFaq: 'toFaq',
  sendSuccessMessage: 'sendSuccessMessage',
  sendErrorMessage: 'sendErrorMessage'
}; export default Keys;